// extracted by mini-css-extract-plugin
export default {"stickyBar":"_5bd9713b","closeButton":"_22c60415","criteoVisible":"_b03d283d"};